@let legendToShowValue = legendToShow();

<div class="route-legend-wrapper-zone">
  @switch (legendToShowValue) {
    <!-- FALL 1: ALTERNATIVE WINTER-BEDINGUNGEN (rsc1) -->
    @case ('rsc1') {
      <table class="fcst-legend-table legend-layout--vertical">
        @for (
          translation of translationWinter;
          track $index;
          let type = $index
        ) {
          <tr class="legend-header-divider-row">
            <th colspan="2" class="vertical-group-title"></th>
          </tr>

          @for (level of [0, 1, 2]; track $index) {
            @if (conditions[type][level] !== 19) {
              <tr class="legend-data-row">
                <td
                  class="cell-color-block"
                  [ngClass]="conditions[type][level] | colorMappingCond"></td>
                <td class="cell-text-label">
                  {{
                    'MAPPING.CONDITION.' + conditions[type][level] | translate
                  }}
                </td>
              </tr>
            }
          }
        }
      </table>
    }

    <!-- FALL 2: STANDARDIZIERTE WINTER-BEDINGUNGEN HORIZONTAL (rsc) -->
    @case ('rsc') {
      <table class="fcst-legend-table legend-layout--horizontal-complex">
        <thead>
          <tr class="legend-text-row-labels">
            @for (
              translation of translationWinter;
              track $index;
              let type = $index
            ) {
              <td
                [colSpan]="type === 0 ? 1 : 3"
                class="legend-label-group-header">
                {{ 'PRODUCT.ROUTEFCST.LEGENDE.' + translation | translate }}
              </td>
            }
          </tr>
        </thead>
        <tbody>
          <tr class="legend-color-bar-row">
            @for (
              translation of translationWinter;
              track $index;
              let type = $index
            ) {
              @for (level of [0, 1, 2]; track $index) {
                @if (conditions[type][level] !== 19) {
                  <td
                    class="color-bar-segment"
                    [ngClass]="conditions[type][level] | colorMappingCond"
                    [matTooltip]="
                      'MAPPING.CONDITION.' + conditions[type][level] | translate
                    "></td>
                }
              }
            }
          </tr>
        </tbody>
      </table>
    }

    <!-- FALL 3: STRAẞENOBERFLÄCHEN-TEMPERATUR (rst) -->
    @case ('rst') {
      <table class="fcst-legend-table legend-layout--horizontal-flat">
        <tbody>
          <tr class="legend-color-bar-row is-labeled-bar">
            @for (temp of roadTemperatures; track $index; let type = $index) {
              <td
                class="color-bar-segment text-overlay-cell"
                [ngClass]="type | colorMappingTemp">
                <span class="segment-inner-label"
                  >{{ temp }}{{ 'UNIT.temp' | translate }}</span
                >
              </td>
            }
          </tr>
        </tbody>
      </table>
    }

    <!-- FALL 4: WARNSTUFEN (warn) -->
    @case ('warn') {
      <table class="fcst-legend-table legend-layout--horizontal-flat">
        <tbody>
          <tr class="legend-color-bar-row is-labeled-bar">
            @for (level of roadWarnLevels; track $index; let type = $index) {
              <td
                class="color-bar-segment text-overlay-cell"
                [ngClass]="type | colorMappingWarn">
                <span class="segment-inner-label">
                  {{ 'PRODUCT.ROUTEFCST.LEGENDE.LEVEL' | translate }}
                  {{ level }}
                </span>
              </td>
            }
          </tr>
        </tbody>
      </table>
    }

    <!-- FALL 5: STREU-INDEX GLÄTTEPOTENZIAL (igp) -->
    @case ('igp') {
      <table class="fcst-legend-table legend-layout--horizontal-dynamic">
        <tbody>
          <tr class="legend-color-bar-row is-labeled-bar">
            @for (row of igpLegend(); track $index) {
              @if (row.hasOwnProperty('value')) {
                <td
                  class="color-bar-segment text-overlay-cell dynamic-mapped-cell"
                  [ngStyle]="row['style']"
                  [matTooltip]="'MAPPING.' + row['text2'] | translate">
                  <span class="segment-inner-label">{{ row['value'] }}</span>
                </td>
              }
            }
          </tr>
        </tbody>
      </table>
    }

    <!-- FALL 6: STREU-INDEX KONTROLLE / ABTAU-EFFEKT (igc) -->
    @case ('igc') {
      <table class="fcst-legend-table legend-layout--horizontal-dynamic">
        <tbody>
          <tr class="legend-color-bar-row is-labeled-bar">
            @for (row of igcLegend(); track $index) {
              @if (row.hasOwnProperty('value')) {
                <td
                  class="color-bar-segment text-overlay-cell dynamic-mapped-cell"
                  [ngStyle]="row['style']"
                  [matTooltip]="'MAPPING.' + row['text2'] | translate">
                  <span class="segment-inner-label">{{ row['value'] }}</span>
                </td>
              }
            }
          </tr>
        </tbody>
      </table>
    }
  }
</div>
